import { render, staticRenderFns } from "./icon-info.vue?vue&type=template&id=f80333f2"
import script from "./icon-info.vue?vue&type=script&lang=ts"
export * from "./icon-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports